<template>
  <div v-if="count > 0" class="table table--files table--jobs">
    <div v-for="(printer, index) in getInactivePrinters" :key="index">
      <inactive-printer-item :printer="printer"></inactive-printer-item>
      <hr v-if="index < count - 1">
    </div>
  </div>
  <div v-else class="no-invalid-printers">
    <span class="text--muted">{{$t('printers.inactive.noPrinters')}}</span>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  import InactivePrinterItem from "./InactivePrinterItem";

  export default {
    name: 'inactive-printers-list',
    components: {
      InactivePrinterItem
    },
    computed: {
      ...mapGetters(['getInactivePrinters']),

      count() {
        return this.getInactivePrinters.length
      }
    }
  }
</script>

<style scoped>
  .no-invalid-printers {
    width: 100%;
    text-align: center;
    font-size: 16px;
  }
</style>